module.exports = __webpack_public_path__ + "img/samsung.e2dd3364.svg";